export default __webpack_public_path__ + "static/media/erick_saravia.4ee19320.png";